import dayjs from 'dayjs';

/**
 * 时间选项转换为时间组
 */
const timeLabels2Times = (value?: string[]): { min: string; max: string }[] => {
  if (!value || value.length === 0) {
    return [];
  }
  return value.map((v) => {
    const [min, max] = v.split('-');
    return {
      min: dayjs().hour(parseInt(min, 10)).format('HH:00:00'),
      max: dayjs().hour(parseInt(max, 10)).format('HH:00:00'),
    };
  });
};

export { timeLabels2Times };
